// 测试数据
export const testData = [
    {
        id: 1,
        name: '卡拉金',
        subtitle: '4个体面, 2个尺寸',
        image: require('@/common/image/xyb.jpg'),
        description: '表面玉面效果, 极具质感, 少有的金色纹理',
        size: 'W1600*H3200mm',
        thickness: '6/12mm',
        surface: '肌理吸光面',
        substrate: '深灰坯基底',
        notes: [
            'A. C (产品款式)',
            '适用于台面, 墙板, 柜门等',
            '包新花色'
        ],
        styles: [
            { name: 'A款', image: require('@/common/image/xyb.jpg') },
            { name: 'C款', image: require('@/common/image/xyh.jpg') }
        ],
        applications: [
            {
                title: '客厅应用',
                description: '现代客厅设计，岩板作为背景墙',
                image: require('@/common/image/xyb.jpg')
            },
            {
                title: '餐厅应用',
                description: '开放式餐厅空间，岩板装饰墙面',
                image: require('@/common/image/xyh.jpg')
            },
            {
                title: '卧室应用',
                description: '主卧室背景墙设计',
                image: require('@/common/image/xyb.jpg')
            }
        ]
    },
    {
        id: 2,
        name: '巴洛克',
        subtitle: '4个体面, 2个尺寸',
        image: require('@/common/image/xyh.jpg'),
        description: '经典巴洛克风格，奢华典雅的设计',
        size: 'W1200*H2400mm',
        thickness: '6mm',
        surface: '抛光面',
        substrate: '白色坯基底',
        notes: [
            'A. B. C. D (4个款式)',
            '适用于高端住宅装饰',
            '多种尺寸可选'
        ],
        styles: [
            { name: 'A款', image: require('@/common/image/xyh.jpg') },
            { name: 'B款', image: require('@/common/image/xyb.jpg') },
            { name: 'C款', image: require('@/common/image/xyh.jpg') },
            { name: 'D款', image: require('@/common/image/xyb.jpg') }
        ],
        applications: [
            {
                title: '豪华客厅',
                description: '巴洛克风格客厅背景墙',
                image: require('@/common/image/xyh.jpg')
            },
            {
                title: '古典餐厅',
                description: '传统欧式餐厅装饰',
                image: require('@/common/image/xyb.jpg')
            }
        ]
    },
    {
        id: 3,
        name: '哥特灰',
        subtitle: '4个体面, 1个尺寸',
        image: require('@/common/image/xyb.jpg'),
        description: '现代简约风格，灰色调设计',
        size: 'W800*H1600mm',
        thickness: '12mm',
        surface: '哑光面',
        substrate: '灰色坯基底',
        notes: [
            'A. B. C. D (4个款式)',
            '适用于现代简约风格',
            '单一尺寸规格'
        ],
        styles: [
            { name: 'A款', image: require('@/common/image/xyb.jpg') },
            { name: 'B款', image: require('@/common/image/xyh.jpg') },
            { name: 'C款', image: require('@/common/image/xyb.jpg') },
            { name: 'D款', image: require('@/common/image/xyh.jpg') }
        ],
        applications: [
            {
                title: '现代客厅',
                description: '简约现代客厅设计',
                image: require('@/common/image/xyb.jpg')
            },
            {
                title: '办公空间',
                description: '商务办公环境装饰',
                image: require('@/common/image/xyh.jpg')
            },
            {
                title: '酒店大堂',
                description: '高端酒店大堂装饰',
                image: require('@/common/image/xyb.jpg')
            }
        ]
    },
    {
        id: 4,
        name: '铂金釉面',
        subtitle: '1个饰面, 1个尺寸',
        image: require('@/common/image/xyh.jpg'),
        description: '铂金质感，高端奢华体验',
        size: 'W1000*H2000mm',
        thickness: '8mm',
        surface: '釉面处理',
        substrate: '白色坯基底',
        notes: [
            '单一款式',
            '适用于高端装饰',
            '铂金质感'
        ],
        styles: [
            { name: '铂金款', image: require('@/common/image/xyh.jpg') }
        ],
        applications: [
            {
                title: '豪华别墅',
                description: '别墅客厅背景墙',
                image: require('@/common/image/xyh.jpg')
            },
            {
                title: '会所装饰',
                description: '高端会所空间装饰',
                image: require('@/common/image/xyb.jpg')
            }
        ]
    },
    {
        id: 5,
        name: '孔雀绿',
        subtitle: '4个场面, 1个尺寸',
        image: require('@/common/image/xyb.jpg'),
        description: '孔雀绿色彩，自然清新',
        size: 'W900*H1800mm',
        thickness: '10mm',
        surface: '自然面',
        substrate: '绿色坯基底',
        notes: [
            'A. B. C. D (4个款式)',
            '适用于自然风格',
            '绿色环保'
        ],
        styles: [
            { name: 'A款', image: require('@/common/image/xyb.jpg') },
            { name: 'B款', image: require('@/common/image/xyh.jpg') },
            { name: 'C款', image: require('@/common/image/xyb.jpg') },
            { name: 'D款', image: require('@/common/image/xyh.jpg') }
        ],
        applications: [
            {
                title: '自然客厅',
                description: '自然风格客厅装饰',
                image: require('@/common/image/xyb.jpg')
            },
            {
                title: '花园餐厅',
                description: '花园式餐厅装饰',
                image: require('@/common/image/xyh.jpg')
            }
        ]
    },
    {
        id: 6,
        name: '墨玉',
        subtitle: '1个体面, 1个尺寸',
        image: require('@/common/image/xyh.jpg'),
        description: '墨玉质感，深邃典雅',
        size: 'W600*H1200mm',
        thickness: '15mm',
        surface: '磨砂面',
        substrate: '黑色坯基底',
        notes: [
            '单一款式',
            '适用于古典风格',
            '墨玉质感'
        ],
        styles: [
            { name: '墨玉款', image: require('@/common/image/xyh.jpg') }
        ],
        applications: [
            {
                title: '古典书房',
                description: '古典风格书房装饰',
                image: require('@/common/image/xyh.jpg')
            },
            {
                title: '茶室',
                description: '传统茶室装饰',
                image: require('@/common/image/xyb.jpg')
            }
        ]
    },
    {
        id: 7,
        name: '鱼肚白',
        subtitle: '3个饰面, 2个尺寸',
        image: require('@/common/image/xyb.jpg'),
        description: '纯净白色，简约大方',
        size: 'W1400*H2800mm',
        thickness: '6/12mm',
        surface: '抛光面',
        substrate: '白色坯基底',
        notes: [
            'A. B. C (3个款式)',
            '适用于简约风格',
            '双尺寸可选'
        ],
        styles: [
            { name: 'A款', image: require('@/common/image/xyb.jpg') },
            { name: 'B款', image: require('@/common/image/xyh.jpg') },
            { name: 'C款', image: require('@/common/image/xyb.jpg') }
        ],
        applications: [
            {
                title: '简约客厅',
                description: '简约风格客厅装饰',
                image: require('@/common/image/xyb.jpg')
            },
            {
                title: '现代厨房',
                description: '现代厨房台面装饰',
                image: require('@/common/image/xyh.jpg')
            },
            {
                title: '浴室',
                description: '现代浴室装饰',
                image: require('@/common/image/xyb.jpg')
            }
        ]
    },
    {
        id: 8,
        name: '莫兰迪',
        subtitle: '2个饰面, 1个尺寸',
        image: require('@/common/image/xyh.jpg'),
        description: '莫兰迪色系，温柔优雅',
        size: 'W1000*H2000mm',
        thickness: '8mm',
        surface: '哑光面',
        substrate: '米色坯基底',
        notes: [
            'A. B (2个款式)',
            '适用于温柔风格',
            '莫兰迪色系'
        ],
        styles: [
            { name: 'A款', image: require('@/common/image/xyh.jpg') },
            { name: 'B款', image: require('@/common/image/xyb.jpg') }
        ],
        applications: [
            {
                title: '温柔卧室',
                description: '温柔风格卧室装饰',
                image: require('@/common/image/xyh.jpg')
            },
            {
                title: '儿童房',
                description: '儿童房装饰',
                image: require('@/common/image/xyb.jpg')
            }
        ]
    }
] 